import { render } from "./WalletTradesTab.vue?vue&type=template&id=92f65a04&scoped=true"
import script from "./WalletTradesTab.vue?vue&type=script&lang=js"
export * from "./WalletTradesTab.vue?vue&type=script&lang=js"

import "./WalletTradesTab.vue?vue&type=style&index=0&id=92f65a04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92f65a04"]])

export default __exports__